"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
const vue_timeline_1 = require("@xenodrive/vue-timeline");
exports.default = (0, vue_1.defineComponent)({
    __name: 'MapDriveReport',
    props: {
        lat: {},
        lon: {},
        vehicleData: {}
    },
    setup(__props) {
        const props = __props;
        const currentData = (0, vue_3.ref)({
            time: '0',
            longitude: 0,
            latitude: 0,
            speed: '0',
            direction: 'NE',
            angle: 0,
        });
        const markers = (0, vue_3.computed)(() => {
            /* eslint-disable */
            const directionMap = {
                NONE: 0,
                N: 0,
                NE: 45,
                E: 90,
                SE: 135,
                S: 180,
                SW: 225,
                W: 270,
                NW: 315,
            };
            /* eslint-enable */
            const direction = currentData.value.direction
                ? currentData.value.direction !== 'NONE'
                    ? directionMap[currentData.value.direction]
                    : undefined
                : currentData.value.angle;
            return [
                (0, vue_map_sdk_1.createMarker)({
                    overlay: 'vehicle_active',
                    icon: direction !== undefined ? 'arrow' : undefined,
                    direction: direction !== null && direction !== void 0 ? direction : 0,
                    coordinate: (0, vue_map_sdk_1.fromTokyo)([currentData.value.longitude, currentData.value.latitude]),
                }),
            ];
        });
        const { series, sources } = (0, vue_timeline_1.defineTimelineOptions)({
            sources: {
                vehicleData: (0, vue_3.computed)(() => props.vehicleData),
            },
            series: {
                speed: {
                    data: {
                        source: 'vehicleData',
                        value: 'speed',
                        unit: 'km/h',
                        digits: 0,
                        range: [0, 100],
                    },
                    chart: 'lines',
                },
            },
        });
        const timeRange = (0, vue_3.computed)(() => {
            return props.vehicleData.reduce((acc, val) => [Math.min(acc[0], Date.parse(val.time) / 1000), Math.max(acc[1], Date.parse(val.time) / 1000)], [Infinity, -Infinity]);
        });
        const time = (0, vue_3.ref)(timeRange.value[0]);
        function onTimeChanging(value) {
            if (!value)
                return;
            const t = value.number();
            const found = props.vehicleData.findIndex((data) => Date.parse(data.time) >= t * 1000);
            if (found >= 0)
                setCurrentVehicleData(found);
        }
        function setCurrentVehicleData(idx) {
            const found = props.vehicleData.at(idx);
            if (!found)
                return;
            if (idx <= 1)
                idx = 0;
            else
                idx -= 1;
            const prev = props.vehicleData.at(idx);
            const angle = 90 - (Math.atan2(found.latitude - prev.latitude, found.longitude - prev.longitude) * 180) / Math.PI;
            currentData.value = Object.assign({ angle }, found);
        }
        function onPathClick(e) {
            if (e.hit) {
                if (0 <= e.hit.idx && e.hit.idx < props.vehicleData.length) {
                    setCurrentVehicleData(e.hit.idx);
                    time.value = Date.parse(currentData.value.time) / 1000;
                }
            }
        }
        const mapCenter = (0, vue_3.ref)([+props.lon, +props.lat]);
        const mapZoom = (0, vue_3.ref)(0);
        const map = (0, vue_3.useTemplateRef)('map');
        const extent = (0, vue_3.computed)(() => {
            return pathCoords.value.reduce((acc, val) => [
                Math.min(acc[0], val[0]),
                Math.min(acc[1], val[1]),
                Math.max(acc[2], val[0]),
                Math.max(acc[3], val[1]),
            ], [Infinity, Infinity, -Infinity, -Infinity]);
        });
        (0, vue_3.onMounted)(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const instance = yield ((_a = map.value) === null || _a === void 0 ? void 0 : _a.api.instance);
            function fit() {
                setTimeout(() => {
                    var _a, _b;
                    if ((_a = map.value) === null || _a === void 0 ? void 0 : _a.api.size) {
                        (_b = map.value) === null || _b === void 0 ? void 0 : _b.api.fitToExtent(extent.value, { animation: false });
                    }
                }, 200);
            }
            instance === null || instance === void 0 ? void 0 : instance.on('change:size', () => fit());
            fit();
        }));
        const pathCoords = (0, vue_3.computed)(() => {
            return props.vehicleData.map((data) => (0, vue_map_sdk_1.fromTokyo)([+data.longitude, +data.latitude, +data.speed]));
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Map, {
                ref_key: "map",
                ref: map,
                "zoom-control": "left-top",
                center: mapCenter.value,
                "onUpdate:center": _cache[1] || (_cache[1] = ($event) => ((mapCenter).value = $event)),
                zoom: mapZoom.value,
                "onUpdate:zoom": _cache[2] || (_cache[2] = ($event) => ((mapZoom).value = $event))
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Markers, { markers: markers.value }, null, 8, ["markers"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Path, {
                        coordinates: pathCoords.value,
                        value: (p) => Number(p[2]),
                        flux: "",
                        onClick: onPathClick
                    }, null, 8, ["coordinates", "value"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).SidePanel, {
                        side: "bottom",
                        show: ""
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_timeline_1.Timeline), {
                                height: "96px",
                                series: (0, vue_2.unref)(series),
                                sources: (0, vue_2.unref)(sources),
                                "time-range": timeRange.value,
                                time: time.value,
                                "onUpdate:time": _cache[0] || (_cache[0] = ($event) => ((time).value = $event)),
                                style: { "border-top": "1px solid #ccc" },
                                onTimechanging: onTimeChanging
                            }, null, 8, ["series", "sources", "time-range", "time"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["center", "zoom"]));
        };
    }
});
